export default __webpack_public_path__ + "static/media/Walker's Belt of the Tribes.ab1f900a.jpg";